import React from 'react';
import { XIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
const problems = ['Sentís que sos un "tirabolas" caro y no un profesor serio.', 'Ves que el profe de la cancha de al lado tiene la agenda explotada y vos tenés huecos muertos.', 'Te da vergüenza cobrar más porque sabés que tus clases son siempre iguales.', 'Llegás al domingo sin saber qué preparar y terminás buscando ejercicios en YouTube.', 'Tenés alumnos de distintos niveles y te cuesta ordenar la clase.', 'Sabés que tus alumnos mejoran, pero no tenés cómo demostrárselo.', 'La lluvia, la pista ocupada o un grupo sin energía te obligan a improvisar.'];
export function PilatesProblem() {
  return <section className="bg-padel-dark px-4 py-16 sm:py-24" data-id="element-280" data-mp="1cvg1hi2x5x26">
      <div className="mx-auto max-w-4xl" data-id="element-281" data-mp="1cy291hpt8cke">
        <FadeIn data-id="element-282" data-mp="3smu6vlh8pad6">
          <p className="text-center font-display text-2xl font-bold text-padel-lime" data-id="element-283" data-mp="3smc220gihntn">
            ¿Cuántos domingos más vas a perder así?
          </p>
          <h2 className="mx-auto mt-4 max-w-3xl text-center font-display text-4xl font-black text-white sm:text-5xl" data-id="element-284" data-mp="1yzqz2nyhu3by">
            Amás el pádel, pero terminás los domingos armando clases a las 11 de
            la noche.
          </h2>
          <p className="mt-5 text-center text-lg text-gray-300" data-id="element-285" data-mp="28yyb97thrrxh">
            No es falta de vocación.{' '}
            <span className="text-padel-lime" data-id="element-286" data-mp="23xskhfje6eql">
              Es que nadie te dio un sistema.
            </span>
          </p>
        </FadeIn>

        <div className="mt-10 grid gap-3 sm:grid-cols-2" data-id="element-287" data-mp="2hw8lqqyhjd1c">
          {problems.map((problem, i) => <FadeIn key={problem} delay={i * 0.04} data-id="element-288" data-mp="2dv6v2yimw9az" data-mpi={i}>
              <div className="flex h-full gap-3 rounded-xl border border-padel-muted bg-padel-surface p-4" data-id="element-289" data-mp="2rn39jzrdqkow">
                <XIcon className="h-5 w-5 shrink-0 text-red-400" data-id="element-290" data-mp="2mpv1wt3uxz1w" />
                <p className="text-sm leading-relaxed text-gray-300" data-id="element-291" data-mp="31m2hth88gebd">
                  {problem}
                </p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.3} data-id="element-292" data-mp="33qz700x8a40r">
          <p className="mt-10 text-center font-display text-3xl font-black text-white" data-id="element-293" data-mp="33rqt8l4xqped">
            ¿Y si este fuera el{' '}
            <span className="text-padel-lime" data-id="element-294" data-mp="38q21wsjhutv0">último domingo</span> que pasás
            así?
          </p>
        </FadeIn>
      </div>
    </section>;
}